import defaultApi from '@/utils/request';

export default {
  // == S20W2001 專案申請及維護作業 ==
  S20W2001_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2001_Load',
      params,
    });
  },
  S20W2001_getSleprjList(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2001_getSleprjList',
      params,
    });
  },
  S20W2001_getPrjinfo(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2001_getPrjinfo',
      params,
    });
  },
  S20W2001_getNuserList(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2001_getNuserList',
      params,
    });
  },
  S20W2001_getSlebugList(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2001_getSlebugList',
      params,
    });
  },
  S20W2001_getSlebugDtlr(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2001_getSlebugDtlr',
      params,
    });
  },
  S20W2001_getSlebugDetList(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2001_getSlebugDetList',
      params,
    });
  },
  S20W2001_getSlebugSel(params) {
    // 預算名稱 select
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2001_getSlebugSel',
      params,
    });
  },
  S20W2001_getSlebugExDetial(params) {
    // 預算執行明細
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2001_getSlebugExDetial',
      params,
    });
  },
  S20W2001_getPagePdf(params) {
    // 列印頁面: 預算執行明細列表
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2001_getPagePdf',
      responseType: 'blob',
      params,
    });
  },
  S20W2001_getSleWorkList(params) {
    // 取得專案人員列表
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2001_getSleWorkList',
      params,
    });
  },
  S20W2001_getSleWorker(params) {
    // 取得專案人員詳細資料
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2001_getSleWorker',
      params,
    });
  },
  S20W2001_getS1ePeoList(params) {
    // 載入計畫研究人員
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2001_getS1ePeoList',
      params,
    });
  },
  S20W2001_getS1eNuserList(params) {
    // 取得專案承辦人
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2001_getS1eNuserList',
      params,
    });
  },
  S20W2001_getS1eAcc(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2001_getS1eAcc',
      params,
    });
  },
  S20W2001_getHadInput(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2001_getHadInput',
      params,
    });
  },
  S20W2001_SaveApply(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2001_SaveApply',
      data,
    });
  },
  S20W2001_saveS1ewokPermiss(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2001_saveS1ewokPermiss',
      data,
    });
  },
  S20W2001_doUpdate(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2001_doUpdate',
      data,
    });
  },
  S20W2001_updS1eStts(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2001_updS1eStts',
      data,
    });
  },
  S20W2001_delS1ewoker(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2001_delS1ewoker',
      data,
    });
  },
  S20W2001_saveS1eNuser(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2001_saveS1eNuser',
      data,
    });
  },
  S20W2001_delS1eNuser(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2001_delS1eNuser',
      data,
    });
  },
  // == S20W2002 專案人員每月薪資產生 start===================
  S20W2002_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2002_Load',
      params,
    });
  },
  S20W2002_Query(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2002_Query',
      params,
    });
  },
  S20W2002_savAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2002_savAction',
      data,
    });
  },
  S20W2002_doFlow(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2002_doFlow',
      params,
    });
  },
  // == S20W2002 專案人員每月薪資產生 end=====================
  // == S20W2003 受款人資料維護作業 ==
  S20W2003_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2003_Load',
      params,
    });
  },
  S20W2003_Query(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2003_Query',
      params,
    });
  },
  S20W2003_savAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2003_savAction',
      data,
    });
  },
  // == S20W2004 預算編列作業 ==
  S20W2004_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2004_Load',
      params,
    });
  },
  S20W2004_Query(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2004_Query',
      params,
    });
  },
  S20W2004_getPagePdf(params) {
    // 列印頁面
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2004_getPagePdf',
      responseType: 'blob',
      params,
    });
  },
  S20W2004_savAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2004_savAction',
      data,
    });
  },
  // ======================================================================================
  S20W2005_LoadPrintFormPDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2005_LoadPrintFormPDF',
      responseType: 'blob',
      params,
    });
  },
  S20W2005_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2005_Load',
      params,
    });
  },
  S20W2005_Query(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2005_Query',
      params,
    });
  },
  // =============================================
  S20W2005_PlanAttachmentViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2005_PlanAttachmentViewLoad',
      params,
    });
  },
  S20W2005_PlanAttachmentViewFileUpload(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2005_PlanAttachmentViewFileUpload',
      data,
    });
  },
  S20W2005_PlanAttachmentViewFileDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2005_PlanAttachmentViewFileDelete',
      data,
    });
  },
  S20W2005_Approve_cancel(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2005_Approve_cancel',
      data,
    });
  },
  S20W2005_Approve(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2005_Approve',
      data,
    });
  },
  S20W2005_ApproveResend(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2005_ApproveResend',
      data,
    });
  },
  S20W2005_Cancel(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2005_Cancel',
      data,
    });
  },
  S20W2005_DelActiExp(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2005_DelActiExp',
      data,
    });
  },
  S20W2005_LoadAdd(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2005_LoadAdd',
      params,
    });
  },
  S20W2005_GetPrj(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2005_GetPrj',
      params,
    });
  },
  S20W2005_GetAcntSubject(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2005_GetAcntSubject',
      params,
    });
  },
  S20W2005_GetAcntSubjectList(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2005_GetAcntSubjectList',
      params,
    });
  },
  S20W2005_Save(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2005_Save',
      data,
    });
  },
  S20W2005_SaveEdit(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2005_SaveEdit',
      data,
    });
  },
  S20W2005_LoadEdit(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2005_LoadEdit',
      params,
    });
  },
  S20W2005_LoadBrilliant(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2005_LoadBrilliant',
      params,
    });
  },
  S20W2005_LoadBdgFrom(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2005_LoadBdgFrom',
      params,
    });
  },
  S20W2005_checkSubmit(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2005_checkSubmit',
      params,
    });
  },
  S20W2005_browse(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2005_browse',
      params,
    });
  },
  // == S20W2009 申購單作業 ===========================
  S20W2009_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2009_Load',
      params,
    });
  },
  S20W2009_Query(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2009_Query',
      params,
    });
  },
  S20W2009_getPagePdf(params) {
    // 列印頁面: 預算執行明細列表
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2009_getPagePdf',
      responseType: 'blob',
      params,
    });
  },
  S20W2009_doFlow(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2009_doFlow',
      params,
    });
  },
  S20W2009_savAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2009_savAction',
      data,
    });
  },
  S20W2009_AttachmentViewFileUpload(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2009_AttachmentViewFileUpload',
      data,
    });
  },
  S20W2009_AttachmentViewFileDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2009_AttachmentViewFileDelete',
      data,
    });
  },

  /* -------------------- S20W2006 請款核銷單(預算執行) Start -------------------- */
  S20W2006_DoSubmitCheck(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2006_DoSubmitCheck',
      params,
    });
  },
  S20W2006_LoadRepair(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2006_LoadRepair',
      params,
    });
  },
  S20W2006_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2006_Load',
      params,
    });
  },
  S20W2006_DelOfficeTravel(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2006_DelOfficeTravel',
      params,
    });
  },
  S20W2006_DelRepair(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2006_DelRepair',
      params,
    });
  },
  S20W2006_SaveActReport(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2006_SaveActReport',
      data,
    });
  },
  S20W2006_SaveRepairList(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2006_SaveRepairList',
      data,
    });
  },
  S20W2006_SaveOfficeTravel(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2006_SaveOfficeTravel',
      data,
    });
  },
  S20W2006_LoadPaymentDetail(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2006_LoadPaymentDetail',
      params,
    });
  },
  S20W2006_LoadTravel(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2006_LoadTravel',
      params,
    });
  },
  S20W2006_LoadOfficeTravel(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2006_LoadOfficeTravel',
      params,
    });
  },
  S20W2006_doLoadActReportViewData(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2006_doLoadActReportViewData',
      params,
    });
  },
  S20W2006_ClearActReport(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2006_ClearActReport',
      params,
    });
  },
  S20W2006_LoadEditOfficeTravel(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2006_LoadEditOfficeTravel',
      params,
    });
  },
  S20W2006_GetAdvancePaymentRecords(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2006_GetAdvancePaymentRecords',
      params,
    });
  },
  S20W2006_GetAcntSubjectList(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2006_GetAcntSubjectList',
      params,
    });
  },
  S20W2006_GetAcntSubjects(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2006_GetAcntSubjects',
      params,
    });
  },
  S20W2006_HighSchoolLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2006_HighSchoolLoad',
      params,
    });
  },
  S20W2006_LoadActPlan(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2006_LoadActPlan',
      params,
    });
  },
  S20W2006_LoadPrintPerformancePDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2006_LoadPrintPerformancePDF',
      responseType: 'blob',
      params,
    });
  },
  S20W2006_LoadPerformanceFiles(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2006_LoadPerformanceFiles',
      params,
    });
  },
  S20W2006_LoadPrintNotePDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2006_LoadPrintNotePDF',
      responseType: 'blob',
      params,
    });
  },
  S20W2006_LoadPrintTravelPDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2006_LoadPrintTravelPDF',
      responseType: 'blob',
      params,
    });
  },
  S20W2006_LoadPrintFormPDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2006_LoadPrintFormPDF',
      responseType: 'blob',
      params,
    });
  },

  S20W2006_ApproveResend(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2006_ApproveResend',
      data,
    });
  },
  S20W2006_Cancel(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2006_Cancel',
      data,
    });
  },
  S20W2006_Approve_cancel(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2006_Approve_cancel',
      data,
    });
  },
  S20W2006_Approve(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2006_Approve',
      data,
    });
  },

  S20W2006_EditViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2006_EditViewLoad',
      params,
    });
  },
  S20W2006_EditViewAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2006_EditViewAction',
      data,
    });
  },
  S20W2006_BrowseViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2006_BrowseViewLoad',
      params,
    });
  },
  S20W2006_AttachmentViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2006_AttachmentViewLoad',
      params,
    });
  },
  S20W2006_AttachmentViewFileUpload(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2006_AttachmentViewFileUpload',
      data,
    });
  },
  S20W2006_AttachmentViewFileDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2006_AttachmentViewFileDelete',
      data,
    });
  },
  S20W2006_BudgetRecordViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2006_BudgetRecordViewLoad',
      params,
    });
  },
  S20W2006_PayeeViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2006_PayeeViewLoad',
      params,
    });
  },
  S20W2006_PayeeViewImport(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2006_PayeeViewImport',
      data,
    });
  },
  S20W2006_BtrnDtlViewDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2006_BtrnDtlViewDelete',
      data,
    });
  },
  S20W2006_MultiPayeeDetailViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2006_MultiPayeeDetailViewLoad',
      params,
    });
  },
  S20W2006_PayeeViewDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2006_PayeeViewDelete',
      data,
    });
  },
  S20W2006_BillViewDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2006_BillViewDelete',
      data,
    });
  },
  S20W2006_PayeeInfoViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2006_PayeeInfoViewLoad',
      params,
    });
  },
  S20W2006_CreatePayeeViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2006_CreatePayeeViewLoad',
      params,
    });
  },
  S20W2006_SearchPayeeViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2006_SearchPayeeViewLoad',
      params,
    });
  },
  S20W2006_CreatePayeeViewSend(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2006_CreatePayeeViewSend',
      data,
    });
  },
  S20W2006_ZipCitySelectorLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2006_ZipCitySelectorLoad',
      params,
    });
  },
  S20W2006_BillViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2006_BillViewLoad',
      params,
    });
  },
  S20W2006_BillViewImport(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2006_BillViewImport',
      data,
    });
  },

  /* -------------------- S20W2006 請款核銷單(預算執行) End -------------------- */
  /* -------------------- S20W2007 零用金支出(預算執行) Start -------------------- */
  S20W2007_DoSubmitCheck(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2007_DoSubmitCheck',
      params,
    });
  },
  S20W2007_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2007_Load',
      params,
    });
  },
  S20W2007_LoadPrintFormPDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2007_LoadPrintFormPDF',
      responseType: 'blob',
      params,
    });
  },
  S20W2007_Approve_cancel(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2007_Approve_cancel',
      data,
    });
  },
  S20W2007_Cancel(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2007_Cancel',
      data,
    });
  },
  S20W2007_LoadPrintNotePDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2007_LoadPrintNotePDF',
      responseType: 'blob',
      params,
    });
  },
  S20W2007_ApproveResend(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2007_ApproveResend',
      data,
    });
  },
  S20W2007_Approve(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2007_Approve',
      data,
    });
  },
  S20W2007_EditViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2007_EditViewLoad',
      params,
    });
  },
  S20W2007_EditViewAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2007_EditViewAction',
      data,
    });
  },
  S20W2007_GetAcntSubjectList(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2007_GetAcntSubjectList',
      params,
    });
  },
  S20W2007_BtrnDtlViewDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2007_BtrnDtlViewDelete',
      data,
    });
  },
  S20W2007_AttachmentViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2007_AttachmentViewLoad',
      params,
    });
  },
  S20W2007_AttachmentViewFileUpload(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2007_AttachmentViewFileUpload',
      data,
    });
  },
  S20W2007_AttachmentViewFileDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2007_AttachmentViewFileDelete',
      data,
    });
  },
  S20W2007_PayeeViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2007_PayeeViewLoad',
      params,
    });
  },
  S20W2007_MultiPayeeDetailViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2007_MultiPayeeDetailViewLoad',
      params,
    });
  },
  S20W2007_PayeeViewDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2007_PayeeViewDelete',
      data,
    });
  },
  S20W2007_PayeeViewImport(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2007_PayeeViewImport',
      data,
    });
  },
  S20W2007_BillViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2007_BillViewLoad',
      params,
    });
  },
  S20W2007_BillViewImport(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2007_BillViewImport',
      data,
    });
  },
  S20W2007_BillViewDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2007_BillViewDelete',
      data,
    });
  },
  S20W2007_CreatePayeeViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2007_CreatePayeeViewLoad',
      params,
    });
  },
  S20W2007_CreatePayeeViewSend(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2007_CreatePayeeViewSend',
      data,
    });
  },
  S20W2007_ZipCitySelectorLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2007_ZipCitySelectorLoad',
      params,
    });
  },
  S20W2007_LoadRepair(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2007_LoadRepair',
      params,
    });
  },
  S20W2007_SaveRepairList(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2007_SaveRepairList',
      data,
    });
  },
  S20W2007_DelRepair(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2007_DelRepair',
      params,
    });
  },
  /* -------------------- S20W2007 零用金支出(預算執行) End -------------------- */
  /* -------------------- S20W2008 預支單(預算執行) Start -------------------- */
  S20W2008_DoSubmitCheck(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2008_DoSubmitCheck',
      params,
    });
  },
  S20W2008_BtrnDtlViewDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2008_BtrnDtlViewDelete',
      data,
    });
  },
  S20W2008_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2008_Load',
      params,
    });
  },
  S20W2008_LoadPrintNotePDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2008_LoadPrintNotePDF',
      responseType: 'blob',
      params,
    });
  },
  S20W2008_LoadPrintFormPDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2008_LoadPrintFormPDF',
      responseType: 'blob',
      params,
    });
  },
  S20W2008_ApproveResend(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2008_ApproveResend',
      data,
    });
  },
  S20W2008_Cancel(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2008_Cancel',
      data,
    });
  },
  S20W2008_Approve_cancel(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2008_Approve_cancel',
      data,
    });
  },
  S20W2008_Approve(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2008_Approve',
      data,
    });
  },
  S20W2008_AttachmentViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2008_AttachmentViewLoad',
      params,
    });
  },
  S20W2008_AttachmentViewFileUpload(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2008_AttachmentViewFileUpload',
      data,
    });
  },
  S20W2008_AttachmentViewFileDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2008_AttachmentViewFileDelete',
      data,
    });
  },
  S20W2008_EditViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2008_EditViewLoad',
      params,
    });
  },
  S20W2008_EditViewAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2008_EditViewAction',
      data,
    });
  },
  S20W2008_GetAcntSubjects(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2008_GetAcntSubjects',
      params,
    });
  },
  S20W2008_GetAcntSubjectList(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2008_GetAcntSubjectList',
      params,
    });
  },
  S20W2008_PayeeViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2008_PayeeViewLoad',
      params,
    });
  },
  S20W2008_MultiPayeeDetailViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2008_MultiPayeeDetailViewLoad',
      params,
    });
  },
  S20W2008_PayeeViewDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2008_PayeeViewDelete',
      data,
    });
  },
  S20W2008_PayeeViewImport(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2008_PayeeViewImport',
      data,
    });
  },
  S20W2008_CreatePayeeViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2008_CreatePayeeViewLoad',
      params,
    });
  },
  S20W2008_SearchPayeeViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2008_SearchPayeeViewLoad',
      params,
    });
  },
  S20W2008_CreatePayeeViewSend(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2008_CreatePayeeViewSend',
      data,
    });
  },
  S20W2008_ZipCitySelectorLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2008_ZipCitySelectorLoad',
      params,
    });
  },
  /* -------------------- S20W2008 預支單(預算執行) End -------------------- */
  /* -------------------- S20W2010 請款核銷單(非預算項目) Start -------------------- */
  S20W2010_ApproveResend(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2010_ApproveResend',
      data,
    });
  },
  S20W2010_LoadPrintFormPDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2010_LoadPrintFormPDF',
      responseType: 'blob',
      params,
    });
  },

  S20W2010_DoSubmitCheck(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2010_DoSubmitCheck',
      params,
    });
  },

  S20W2010_ImproveAttachmentViewFileDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2010_ImproveAttachmentViewFileDelete',
      data,
    });
  },
  S20W2010_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2010_Load',
      params,
    });
  },
  S20W2010_EditViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2010_EditViewLoad',
      params,
    });
  },
  S20W2010_EditViewAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2010_EditViewAction',
      data,
    });
  },
  S20W2010_BrowseViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2010_BrowseViewLoad',
      params,
    });
  },
  S20W2010_AttachmentViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2010_AttachmentViewLoad',
      params,
    });
  },
  S20W2010_AttachmentViewFileUpload(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2010_AttachmentViewFileUpload',
      data,
    });
  },
  S20W2010_AttachmentViewFileDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2010_AttachmentViewFileDelete',
      data,
    });
  },
  S20W2010_BudgetRecordViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2010_BudgetRecordViewLoad',
      params,
    });
  },
  S20W2010_PayeeViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2010_PayeeViewLoad',
      params,
    });
  },
  S20W2010_PayeeViewImport(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2010_PayeeViewImport',
      data,
    });
  },
  S20W2010_BtrnDtlViewDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2010_BtrnDtlViewDelete',
      data,
    });
  },
  S20W2010_MultiPayeeDetailViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2010_MultiPayeeDetailViewLoad',
      params,
    });
  },
  S20W2010_PayeeViewDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2010_PayeeViewDelete',
      data,
    });
  },
  S20W2010_BillViewDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2010_BillViewDelete',
      data,
    });
  },
  S20W2010_PayeeInfoViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2010_PayeeInfoViewLoad',
      params,
    });
  },
  S20W2010_CreatePayeeViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2010_CreatePayeeViewLoad',
      params,
    });
  },
  S20W2010_SearchPayeeViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2010_SearchPayeeViewLoad',
      params,
    });
  },
  S20W2010_CreatePayeeViewSend(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2010_CreatePayeeViewSend',
      data,
    });
  },
  S20W2010_ZipCitySelectorLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2010_ZipCitySelectorLoad',
      params,
    });
  },
  S20W2010_BillViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2010_BillViewLoad',
      params,
    });
  },
  S20W2010_BillViewImport(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2010_BillViewImport',
      data,
    });
  },

  /* -------------------- S20W2010 請款核銷單(非預算項目) End -------------------- */
  /* -------------------- S20W2013 請款核銷單(改善師資專款) Start -------------------- */
  S20W2013_DoSubmitCheck(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2013_DoSubmitCheck',
      params,
    });
  },

  S20W2013_GetAcntSubjects(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2013_GetAcntSubjects',
      params,
    });
  },

  S20W2013_GetAdvancePaymentRecords(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2013_GetAdvancePaymentRecords',
      params,
    });
  },

  S20W2013_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2013_Load',
      params,
    });
  },
  S20W2013_Approve(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2013_Approve',
      data,
    });
  },
  S20W2013_Approve_cancel(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2013_Approve_cancel',
      data,
    });
  },
  S20W2013_ApproveResend(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2013_ApproveResend',
      data,
    });
  },
  S20W2013_Cancel(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2013_Cancel',
      data,
    });
  },
  S20W2013_LoadPrintFormPDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2013_LoadPrintFormPDF',
      responseType: 'blob',
      params,
    });
  },
  S20W2013_LoadPrintNotePDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2013_LoadPrintNotePDF',
      responseType: 'blob',
      params,
    });
  },
  S20W2013_EditViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2013_EditViewLoad',
      params,
    });
  },
  S20W2013_EditViewAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2013_EditViewAction',
      data,
    });
  },
  S20W2013_BrowseViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2013_BrowseViewLoad',
      params,
    });
  },
  S20W2013_AttachmentViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2013_AttachmentViewLoad',
      params,
    });
  },
  S20W2013_AttachmentViewFileUpload(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2013_AttachmentViewFileUpload',
      data,
    });
  },
  S20W2013_AttachmentViewFileDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2013_AttachmentViewFileDelete',
      data,
    });
  },
  S20W2013_ImproveAttachmentViewFileDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2013_ImproveAttachmentViewFileDelete',
      data,
    });
  },
  S20W2013_BudgetRecordViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2013_BudgetRecordViewLoad',
      params,
    });
  },
  S20W2013_PayeeViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2013_PayeeViewLoad',
      params,
    });
  },
  S20W2013_BtrnDtlViewDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2013_BtrnDtlViewDelete',
      data,
    });
  },
  S20W2013_PayeeViewDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2013_PayeeViewDelete',
      data,
    });
  },
  S20W2013_BillViewDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2013_BillViewDelete',
      data,
    });
  },
  S20W2013_PayeeInfoViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2013_PayeeInfoViewLoad',
      params,
    });
  },
  S20W2013_CreatePayeeViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2013_CreatePayeeViewLoad',
      params,
    });
  },
  S20W2013_SearchPayeeViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2013_SearchPayeeViewLoad',
      params,
    });
  },
  S20W2013_CreatePayeeViewSend(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2013_CreatePayeeViewSend',
      data,
    });
  },
  S20W2013_ZipCitySelectorLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2013_ZipCitySelectorLoad',
      params,
    });
  },
  S20W2013_BillViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2013_BillViewLoad',
      params,
    });
  },
  /* -------------------- S20W2013 請款核銷單(改善師資專款) End -------------------- */
  /* -------------------- S20W2014 預支單(改善師資專款) Start -------------------- */
  S20W2014_DoSubmitCheck(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2014_DoSubmitCheck',
      params,
    });
  },

  S20W2014_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2014_Load',
      params,
    });
  },
  S20W2014_GetAcntSubjectList(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2014_GetAcntSubjectList',
      params,
    });
  },
  S20W2014_LoadActPlan(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2014_LoadActPlan',
      params,
    });
  },

  S20W2014_LoadPrintNotePDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2014_LoadPrintNotePDF',
      responseType: 'blob',
      params,
    });
  },
  S20W2014_LoadPrintFormPDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2014_LoadPrintFormPDF',
      responseType: 'blob',
      params,
    });
  },
  S20W2014_AttachmentViewFileDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2014_AttachmentViewFileDelete',
      data,
    });
  },
  S20W2014_ApproveResend(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2014_ApproveResend',
      data,
    });
  },
  S20W2014_Cancel(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2014_Cancel',
      data,
    });
  },
  S20W2014_Approve_cancel(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2014_Approve_cancel',
      data,
    });
  },
  S20W2014_Approve(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2014_Approve',
      data,
    });
  },
  S20W2014_EditViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2014_EditViewLoad',
      params,
    });
  },
  S20W2014_EditViewAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2014_EditViewAction',
      data,
    });
  },
  S20W2014_BrowseViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2014_BrowseViewLoad',
      params,
    });
  },
  S20W2014_AttachmentViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2014_AttachmentViewLoad',
      params,
    });
  },
  S20W2014_AttachmentViewFileUpload(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2014_AttachmentViewFileUpload',
      data,
    });
  },
  S20W2014_BudgetRecordViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2014_BudgetRecordViewLoad',
      params,
    });
  },
  S20W2014_PayeeViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2014_PayeeViewLoad',
      params,
    });
  },
  S20W2014_BtrnDtlViewDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2014_BtrnDtlViewDelete',
      data,
    });
  },
  S20W2014_PayeeViewDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2014_PayeeViewDelete',
      data,
    });
  },
  S20W2014_BillViewDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2014_BillViewDelete',
      data,
    });
  },
  S20W2014_PayeeInfoViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2014_PayeeInfoViewLoad',
      params,
    });
  },
  S20W2014_CreatePayeeViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2014_CreatePayeeViewLoad',
      params,
    });
  },
  S20W2014_SearchPayeeViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2014_SearchPayeeViewLoad',
      params,
    });
  },
  S20W2014_CreatePayeeViewSend(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2014_CreatePayeeViewSend',
      data,
    });
  },
  S20W2014_ZipCitySelectorLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2014_ZipCitySelectorLoad',
      params,
    });
  },
  S20W2014_BillViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2014_BillViewLoad',
      params,
    });
  },
  /* -------------------- S20W2014 預支單(改善師資專款) End -------------------- */
  // == S20W2015 經費變更流用申請作業 ======================
  S20W2015_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2015_Load',
      params,
    });
  },
  S20W2015_Query(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2015_Query',
      params,
    });
  },
  S20W2015_getPagePdf(params) {
    // 列印頁面: 預算執行明細列表
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2015_getPagePdf',
      responseType: 'blob',
      params,
    });
  },
  S20W2015_doFlow(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2015_doFlow',
      params,
    });
  },
  S20W2015_savAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2015_savAction',
      data,
    });
  },
  S20W2015_AttachmentViewFileUpload(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2015_AttachmentViewFileUpload',
      data,
    });
  },
  S20W2015_AttachmentViewFileDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2015_AttachmentViewFileDelete',
      data,
    });
  },
  // == S20W2015 經費變更流用申請作業 End===================

  // === S20W2012 ================================
  S20W2012_DoSubmitCheck(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2012_DoSubmitCheck',
      params,
    });
  },

  S20W2012_BtrnDtlViewDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2012_BtrnDtlViewDelete',
      data,
    });
  },

  S20W2012_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2012_Load',
      params,
    });
  },
  S20W2012_LoadPrintNotePDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2012_LoadPrintNotePDF',
      responseType: 'blob',
      params,
    });
  },
  S20W2012_LoadPrintFormPDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2012_LoadPrintFormPDF',
      responseType: 'blob',
      params,
    });
  },
  S20W2012_ApproveResend(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2012_ApproveResend',
      data,
    });
  },
  S20W2012_Cancel(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2012_Cancel',
      data,
    });
  },
  S20W2012_Approve_cancel(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2012_Approve_cancel',
      data,
    });
  },
  S20W2012_Approve(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2012_Approve',
      data,
    });
  },
  S20W2012_AttachmentViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2012_AttachmentViewLoad',
      params,
    });
  },
  S20W2012_AttachmentViewFileUpload(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2012_AttachmentViewFileUpload',
      data,
    });
  },
  S20W2012_AttachmentViewFileDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2012_AttachmentViewFileDelete',
      data,
    });
  },
  S20W2012_EditViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2012_EditViewLoad',
      params,
    });
  },
  S20W2012_EditViewAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2012_EditViewAction',
      data,
    });
  },
  S20W2012_GetAcntSubjects(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2012_GetAcntSubjects',
      params,
    });
  },
  S20W2012_GetAcntSubjectList(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2012_GetAcntSubjectList',
      params,
    });
  },
  S20W2012_PayeeViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2012_PayeeViewLoad',
      params,
    });
  },
  S20W2012_MultiPayeeDetailViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2012_MultiPayeeDetailViewLoad',
      params,
    });
  },
  S20W2012_PayeeViewDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2012_PayeeViewDelete',
      data,
    });
  },
  S20W2012_PayeeViewImport(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2012_PayeeViewImport',
      data,
    });
  },
  S20W2012_CreatePayeeViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2012_CreatePayeeViewLoad',
      params,
    });
  },
  S20W2012_SearchPayeeViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2012_SearchPayeeViewLoad',
      params,
    });
  },
  S20W2012_CreatePayeeViewSend(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2012_CreatePayeeViewSend',
      data,
    });
  },
  S20W2012_ZipCitySelectorLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2012_ZipCitySelectorLoad',
      params,
    });
  },

  // =============================================================================

  // ============================ Start of S20W2011 ====================================
  S20W2011_DoSubmitCheck(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2011_DoSubmitCheck',
      params,
    });
  },

  S20W2011_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2011_Load',
      params,
    });
  },
  S20W2011_LoadPrintFormPDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2011_LoadPrintFormPDF',
      responseType: 'blob',
      params,
    });
  },
  S20W2011_Approve_cancel(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2011_Approve_cancel',
      data,
    });
  },
  S20W2011_Cancel(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2011_Cancel',
      data,
    });
  },
  S20W2011_LoadPrintNotePDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2011_LoadPrintNotePDF',
      responseType: 'blob',
      params,
    });
  },
  S20W2011_ApproveResend(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2011_ApproveResend',
      data,
    });
  },
  S20W2011_Approve(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2011_Approve',
      data,
    });
  },
  S20W2011_EditViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2011_EditViewLoad',
      params,
    });
  },
  S20W2011_EditViewAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2011_EditViewAction',
      data,
    });
  },
  S20W2011_GetAcntSubjectList(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2011_GetAcntSubjectList',
      params,
    });
  },
  S20W2011_BtrnDtlViewDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2011_BtrnDtlViewDelete',
      data,
    });
  },
  S20W2011_AttachmentViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2011_AttachmentViewLoad',
      params,
    });
  },
  S20W2011_AttachmentViewFileUpload(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2011_AttachmentViewFileUpload',
      data,
    });
  },
  S20W2011_AttachmentViewFileDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2011_AttachmentViewFileDelete',
      data,
    });
  },
  S20W2011_PayeeViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2011_PayeeViewLoad',
      params,
    });
  },
  S20W2011_MultiPayeeDetailViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2011_MultiPayeeDetailViewLoad',
      params,
    });
  },
  S20W2011_PayeeViewDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2011_PayeeViewDelete',
      data,
    });
  },
  S20W2011_PayeeViewImport(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2011_PayeeViewImport',
      data,
    });
  },
  S20W2011_BillViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2011_BillViewLoad',
      params,
    });
  },
  S20W2011_BillViewImport(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2011_BillViewImport',
      data,
    });
  },
  S20W2011_BillViewDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2011_BillViewDelete',
      data,
    });
  },
  S20W2011_CreatePayeeViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2011_CreatePayeeViewLoad',
      params,
    });
  },
  S20W2011_CreatePayeeViewSend(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2011_CreatePayeeViewSend',
      data,
    });
  },
  S20W2011_ZipCitySelectorLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2011_ZipCitySelectorLoad',
      params,
    });
  },
  S20W2011_LoadRepair(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2011_LoadRepair',
      params,
    });
  },
  S20W2011_SaveRepairList(data) {
    return defaultApi({
      method: 'post',
      url: 'S10/S20/S20W2011_SaveRepairList',
      data,
    });
  },
  S20W2011_DelRepair(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W2011_DelRepair',
      params,
    });
  },

  // ========================  End Of S20W2011 =============================================
  // == S20W4001 單位預算查詢作業 start===================
  S20W4001_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W4001_Load',
      params,
    });
  },
  S20W4001_Query(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W4001_Query',
      params,
    });
  },
  S20W4001_getPagePdf(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W4001_getPagePdf',
      responseType: 'blob',
      params,
    });
  },
  // == S20W4001 單位預算查詢作業 end=====================
  // == S20W4002 申購單進度查詢作業 start==================
  S20W4002_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W4002_Load',
      params,
    });
  },
  S20W4002_Query(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W4002_Query',
      params,
    });
  },
  S20W4002_getPagePdf(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W4002_getPagePdf',
      responseType: 'blob',
      params,
    });
  },
  // == S20W4002 申購單進度查詢作業 end====================
  // == S20W4003 總務處採購/營建工程進度表 start==============
  S20W4003_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W4003_Load',
      params,
    });
  },
  S20W4003_Query(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W4003_Query',
      params,
    });
  },
  S20W4003_getPagePdf(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W4003_getPagePdf',
      responseType: 'blob',
      params,
    });
  },
  // == S20W4003 總務處採購/營建工程進度表 end================
  // == S20W4004 計畫表查詢作業 start====================
  S20W4004_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W4004_Load',
      params,
    });
  },
  S20W4004_Query(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W4004_Query',
      params,
    });
  },
  S20W4004_getPagePdf(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W4004_getPagePdf',
      responseType: 'blob',
      params,
    });
  },
  // == S20W4004 計畫表查詢作業 end======================
  // == S20W4005 成效表查詢作業 start====================
  S20W4005_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W4005_Load',
      params,
    });
  },
  S20W4005_Query(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W4005_Query',
      params,
    });
  },
  // == S20W4005 成效表查詢作業 end======================
  // == S20W4006 預支/請款核銷查詢作業 start================
  S20W4006_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W4006_Load',
      params,
    });
  },
  S20W4006_Query(params) {
    return defaultApi({
      method: 'get',
      url: 'S10/S20/S20W4006_Query',
      params,
    });
  },
  // == S20W4006 預支/請款核銷查詢作業 end==================
  // ================= S20W9001 經費動支、採購暨財產簽核作業(整合) =========================
  S20W9001_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S12/S20/S20W9001_Load',
      params,
    });
  },
  // 因為要傳遞 array 資料，無法使用 httpget 傳遞，改為 httppost
  S20W9001_GetListContent(data) {
    return defaultApi({
      method: 'post',
      url: 'S12/S20/S20W9001_GetListContent',
      data,
    });
  },
  S20W9001_GetPhrase(params) {
    return defaultApi({
      method: 'get',
      url: 'S12/S20/S20W9001_GetPhrase',
      params,
    });
  },
  S20W9001_GetLeaveForm(params) {
    return defaultApi({
      method: 'get',
      url: 'S12/S20/S20W9001_GetLeaveForm',
      params,
    });
  },
  S20W9001_SubmitApply(data) {
    return defaultApi({
      method: 'post',
      url: 'S12/S20/S20W9001_SubmitApply',
      data,
    });
  },
  S20W9001_SubmitApply_501(data) {
    return defaultApi({
      method: 'post',
      url: 'S12/S20/S20W9001_SubmitApply_501',
      data,
    });
  },
  S20W9001_GetCancelVacation(params) {
    return defaultApi({
      method: 'get',
      url: 'S12/S20/S20W9001_GetCancelVacation',
      params,
    });
  },
  S20W9001_GetFileList(params) {
    return defaultApi({
      method: 'get',
      url: 'S12/S20/S20W9001_GetFileList',
      params,
    });
  },
  S20W9001_GetFileList_513(params) {
    return defaultApi({
      method: 'get',
      url: 'S12/S20/S20W9001_GetFileList_513',
      params,
    });
  },
  S20W9001_GetZPC002PASS(data) {
    return defaultApi({
      method: 'post',
      url: 'S12/S20/S20W9001_GetZPC002PASS',
      data,
    });
  },
  S20W9001_GetZPC002PASSAP(data) {
    return defaultApi({
      method: 'post',
      url: 'S12/S20/S20W9001_GetZPC002PASSAP',
      data,
    });
  },
  S20W9001_GetZPC003PASS(data) {
    return defaultApi({
      method: 'post',
      url: 'S12/S20/S20W9001_GetZPC003PASS',
      data,
    });
  },
  S20W9001_GetZPC003PASSAP(data) {
    return defaultApi({
      method: 'post',
      url: 'S12/S20/S20W9001_GetZPC003PASSAP',
      data,
    });
  },
  S20W9001_GetLeave(params) {
    return defaultApi({
      method: 'get',
      url: 'S12/S20/S20W9001_GetLeave',
      params,
    });
  },
  S20W9001_GetPrjInfo(params) {
    return defaultApi({
      method: 'get',
      url: 'S12/S20/S20W9001_GetPrjInfo',
      params,
    });
  },
  S20W9001_SubmitApply_507(data) {
    return defaultApi({
      method: 'post',
      url: 'S12/S20/S20W9001_SubmitApply_507',
      data,
    });
  },
  S20W9001_SaveJobadd(data) {
    return defaultApi({
      method: 'post',
      url: 'S12/S20/S20W9001_SaveJobadd',
      data,
    });
  },
  S20W9001_SaveTutor(data) {
    return defaultApi({
      method: 'post',
      url: 'S12/S20/S20W9001_SaveTutor',
      data,
    });
  },
  S20W9001_GetPrjSalary(data) {
    return defaultApi({
      method: 'post',
      url: 'S12/S20/S20W9001_GetPrjSalary',
      data,
    });
  },
  S20W9001_GetStaffSalary(data) {
    return defaultApi({
      method: 'post',
      url: 'S12/S20/S20W9001_GetStaffSalary',
      data,
    });
  },
  S20W9001_GetMonthSalary(data) {
    return defaultApi({
      method: 'post',
      url: 'S12/S20/S20W9001_GetMonthSalary',
      data,
    });
  },
  S20W9001_SubmitApply_505(data) {
    return defaultApi({
      method: 'post',
      url: 'S12/S20/S20W9001_SubmitApply_505',
      data,
    });
  },
  S20W9001_SubmitApply_506(data) {
    return defaultApi({
      method: 'post',
      url: 'S12/S20/S20W9001_SubmitApply_506',
      data,
    });
  },
  S20W9001_SubmitApply_513(data) {
    return defaultApi({
      method: 'post',
      url: 'S12/S20/S20W9001_SubmitApply_513',
      data,
    });
  },
  S20W9001_PlanAttachmentViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S12/S20/S20W9001_PlanAttachmentViewLoad',
      params,
    });
  },
  S20W9001_PlanAttachmentViewFileUpload(data) {
    return defaultApi({
      method: 'post',
      url: 'S12/S20/S20W9001_PlanAttachmentViewFileUpload',
      data,
    });
  },
  S20W9001_PlanAttachmentViewFileDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S12/S20/S20W9001_PlanAttachmentViewFileDelete',
      data,
    });
  },
};
